// Copyright ©️ 2026 eVolve MEP, LLC

import { Button, Text } from '@mantine/core';

import type { NavOption } from 'app/Layout/NavBar/globalNavigationMenu';
import { navbarTransitionStyle } from 'app/Layout/NavBar/useAppShell';
import { EvolveIcon, type EvolveIconName } from 'assets/icons/EvolveIcon';

import classes from './NavSectionHeader.module.css';

type Props = {
  navData: {
    label: string;
    icon: EvolveIconName;
    options: NavOption[];
  };
  navbarExpanded: boolean;
  navOptionsOpened: boolean;
  onClick: () => void;
};

export const NavSectionHeader = ({ navData, navbarExpanded, navOptionsOpened, onClick }: Props) => (
  <Button
    fullWidth
    style={{
      'transition': navbarTransitionStyle,
      'alignItems': 'center',
      '--button-hover': 'var(--mantine-color-app-shell-gray-7)',
    }}
    classNames={{
      section: classes.section,
    }}
    p={5}
    size="input-sm"
    justify="flex-start"
    leftSection={<EvolveIcon icon={navData.icon} color="app-shell-gray.5" />}
    rightSection={
      <EvolveIcon
        icon={navOptionsOpened ? 'NavCollapseOpen' : 'NavCollapseCollapsed'}
        color="app-shell-gray.5"
        spanProps={{
          className: classes.collapseCaret,
        }}
      />
    }
    variant="transparent"
    onClick={onClick}
  >
    <Text className={classes.text} h={navbarExpanded ? undefined : 0} opacity={navbarExpanded ? 1 : 0}>
      {navData.label}
    </Text>
  </Button>
);
